module.exports = __webpack_public_path__ + "img/cloudy.d0af9dce.svg";